import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import ProductDetailsTable from "../../../Components/Table/ProductDetailsTable";
import { GetSingleOrder } from "../../../APIs/Function/Order/GetSingleOrder";
import Loader2 from "../../../Components/Loader/Loader2";

const OrderDetails = () => {
  const { id } = useParams();
  const [orderData, setOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleSingleOrder = async () => {
    try {
      setLoading(true);
      let res = await GetSingleOrder(id);
      setOrderData(res.r);
      console.log(res.r)
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleOrder();
  }, []);
  
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader2 />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/order"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Order Details
              </Typography>
            </Box>
            <Box></Box>
          </Box>
          <Box
            sx={{
              border: "solid 1px #DDDDDD",
              width: "80%",
              m: "auto",
              mt: 1,
              p: 2,
              boxSizing: "border-box",
              height: "50vh",
              display: "flex",
            }}
          >
            <Box sx={{ width: "50%" }}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  Order ID
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  {orderData?.unique_order_id}
                </Typography>
              </Box>
              <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              <Box>
                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  No. of Items Purchased
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  {orderData?.no_of_products}
                </Typography>{" "}
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>
            </Box>
            <Divider
              orientation="vertical"
              sx={{ border: "1px solid ##E9E9E9" }}
              flexItem
            />
            <Box sx={{ width: "50%", ml: 3, height: "46vh",overflow:'auto' }}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  Username
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  {orderData?.user_name}
                </Typography>{" "}
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>{" "}
              <Box>
                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  Email
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  {orderData?.email}
                </Typography>{" "}
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>{" "}
              <Box>
                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  Phone Number
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  14498415151
                </Typography>{" "}
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>{" "}
              <Box>
                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  No. of Items
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  {orderData?.no_of_items}
                </Typography>{" "}
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>{" "}
              <Box>
                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  Order Status
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  {orderData?.status === 0
                    ? "Pending"
                    : orderData?.status === 1
                    ? "Ready To Dispatch"
                    : orderData?.status === 2
                    ? "Completed"
                    : "Failed"}
                </Typography>
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>{" "}
              <Box>
                <Typography
                  sx={{
                    mt: 1,
                    fontFamily: "Inter",
                    fontSize: "15px",
                    fontWeight: 500,
                    color: "#787878",
                    textAlign: "left",
                  }}
                >
                  Total Price
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "left",
                  }}
                >
                  $25
                </Typography>{" "}
                <Divider color={"#DEDEDE"} width={"95%"} height={"1px"} />
              </Box>
            </Box>
          </Box>
          <Box sx={{ width: "80%", m: "auto", mt: 1 }}>
            <Typography
              sx={{ textAlign: "left", fontSize: "20px", fontWeight: 180 }}
            >
              Product Details:
            </Typography>
            <Box sx={{ height: "29vh", overflow: "auto" }}>
              <ProductDetailsTable productData={orderData} />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default OrderDetails;
